module.exports = __webpack_public_path__ + "static/logo-410bf7c5ab8d6ef83d63610b3cc6bb91.png";